import {
  LengthSchema,
  WeightSchema,
} from "@redotech/redo-fulfillment-outbound-labels-common/util";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { CustomParcelType } from "../outbound-labels/parcel";
import { HazmatSchema } from "./hazmat";

// Unlike the V1 parcel, V2 parcels declare their own units and carry no customs
// info (customs is shipment-level in V2). Kept in its own leaf module so the
// rate schema (outbound-labels) can reference it without a cycle through
// outbound-shipment.
const outboundShipmentParcelV2Schema = z.object({
  length: LengthSchema.nullish(),
  width: LengthSchema.nullish(),
  height: LengthSchema.nullish(),
  weight: WeightSchema,
  predefined_package: z.string().nullish(),
  parcelType: createEnum(CustomParcelType, {
    enumName: "CustomParcelType",
  }).nullish(),
  additionalHandlingIndicator: z.boolean().nullish(),
  largePackageIndicator: z.boolean().nullish(),
  shipperReleaseIndicator: z.boolean().nullish(),
  // Hazmat and dry ice are per parcel in V2 (V1 carried them at the shipment
  // level). dry_ice_weight is unit-aware ({ unit, value }).
  hazmat: HazmatSchema.nullish(),
  dry_ice: z.boolean().nullish(),
  dry_ice_weight: WeightSchema.nullish(),
});

export const OutboundShipmentParcelV2Schema = outboundShipmentParcelV2Schema;

export interface OutboundShipmentParcelV2 extends z.infer<
  typeof outboundShipmentParcelV2Schema
> {}
